import { ABTestID } from '@core/abTesting/types'

import { addTest } from './abTesting'

/**
 * bucket users in 95% traffic widget display test
 */
export function add95PercentTrafficTest() {
  addTest({
    id: ABTestID.NINETY_FIVE_PERCENT_TRAFFIC_WIDGET_DISPLAY,
    buckets: [
      {
        id: 'invisible',
        weight: 5,
      },
      {
        id: 'visible',
        weight: 95,
      },
    ],
  })
}
